import { graphql } from "@/gql";

export const GUARD_ME_QUERY = graphql(`
  query GUARD_ME_QUERY($id: String!) {
    guardme(id: $id) {
      id
      shortId
      notes
      status
      completedAt
      createdAt
      endsAt
      updatedAt
      memberId
      member {
        id
        ...GUARDME_MEMBER_DETAILS_FRAGMENT
      }
      organizationId
      organization {
        id
        memberMetadataFields
        settingIsRapidsosPanicButtonFlowEnabled
        settingIsRapidsosOperatorFlowEnabled
        settingRapidsosSocPhoneNumber
      }
      ...GUARDME_SESSION_DETAILS_FRAGMENT
    }
  }
`);

export const GUARDME_SESSION_DETAILS_FRAGMENT = graphql(`
  fragment GUARDME_SESSION_DETAILS_FRAGMENT on Guardme {
    id
    completedAt
    createdAt
    endsAt
    totalAttachments
    batteryLevel
  }
`);

export const GUARDME_MEMBER_DETAILS_FRAGMENT = graphql(`
  fragment GUARDME_MEMBER_DETAILS_FRAGMENT on Member {
    id
    organizationId
    fullName
    displayName
    timezone
    avatarUrl
    phoneNumber
    emailAddress
    metadata
    organization {
      id
      memberMetadataFields
    }
  }
`);
